<template>
    <el-row>
    <el-col :span="24">
    <el-select size="mini" v-model="selectfunc" :placeholder="$t('agent.selectM', { msg: 'agent.selectM' })" style="margin-right: 10px;width: 135px; float: left">
        <el-option
        v-for="item in allselectfunc"
        :key="item.label"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
    <el-input v-model="search" size="mini" :placeholder="$t('agent.select', { msg: 'agent.select' })" style=" width: 500px;margin-bottom:10px; float: left"/>
        <el-col :span="4">
         <el-button @click="selectFunc()" size="mini" type="primary" style="margin-left: 10px">{{ $t('kbinfo.select', { msg: 'kbinfo.select' }) }}</el-button>
         <el-button @click="reset()" size="mini" type="danger">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
        </el-col>

        <el-button style="float: right" size="mini" type="primary" @click="newAgentVisiableFunc()">{{ $t('agent.new', { msg: 'agent.new' }) }}</el-button>

    </el-col>
    </el-row>
    <el-table :data="tabelData"
            style="width: 100%"
            v-loading="loading"
            stripe
            border
            highlight-current-row
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            >
        <el-table-column label="id" prop="id" v-if="false"></el-table-column>
        <el-table-column :label="$t('agent.id', { msg: 'agent.id' })" prop="agentCode" align="center"></el-table-column>
        <el-table-column :label="$t('agent.name', { msg: 'agent.name' })" prop="agentName" align="center"></el-table-column>
        <el-table-column :label="$t('agent.companyName', { msg: 'agent.companyName' })" prop="companyName" align="center"></el-table-column>
        <el-table-column :label="$t('agent.contact', { msg: 'agent.contact' })" prop="agentContact" align="center"></el-table-column>
        <el-table-column :label="$t('agent.logo', { msg: 'agent.logo' })" prop="agentLogo" align="center">
        <template #default="scope">
        <el-image :src="scope.row.agentLogo" style="width: 50px ; height: 50px ;display: block; margin: 0 auto;">
            <div slots="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
        </template>
        </el-table-column>
        <el-table-column :label="$t('agent.opr', { msg: 'agent.opr' })" prop="operation" align="center">
        <template #default="scope">
            <el-button size="mini" type="danger" @click="delAgent(scope.$index, scope.row.id)">{{ $t('agent.btn.delete', { msg: 'agent.btn.delete' }) }}</el-button>
        </template>
      </el-table-column>
    </el-table> 
    
    <el-dialog :title="$t('agent.new', { msg: 'agent.new' })" v-model="newAgentVisiable">
        <el-form label-width="120px" :model="newAgentForm" :rules="newAgentRules" ref="newAgentForm">
            <el-form-item :label="$t('agent.id', { msg: 'agent.id' })" prop="agentCode">
                <el-input v-model="newAgentForm.agentCode" :placeholder="$t('agent.idD', { msg: 'agent.idD' })"></el-input>
            </el-form-item>
            <el-form-item :label="$t('agent.name', { msg: 'agent.name' })" prop="agentName">
                <el-input v-model="newAgentForm.agentName" :placeholder="$t('agent.nameD', { msg: 'agent.nameD' })"></el-input>
            </el-form-item>
            <el-form-item :label="$t('agent.companyName', { msg: 'agent.companyName' })" prop="companyName">
                <el-select style="width: 100%" v-model="newAgentForm.companyName" :placeholder="$t('agent.companyNameD', { msg: 'agent.companyNameD' })" @click="getAllCompany()">
                    <el-option v-for="item in allCompany"
                                :key="item.key"
                                :label="item.label"
                                :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('agent.contact', { msg: 'agent.contact' })" prop="agentContact">
                <el-input v-model="newAgentForm.agentContact" :placeholder="$t('agent.contactD', { msg: 'agent.contactD' })"></el-input>
            </el-form-item>
            <el-form-item :label="$t('agent.logo', { msg: 'agent.logo' })" prop="agentLogo">
                <el-upload
                    class="upload"
                    limit=1
                    drag
                    :action="uploadUrl"
                    :on-success="handleUploadSuccess"
                    :before-upload="handleBeforeUpload"
                    ref="img"
                >
                    <el-icon class="el-icon-upload"><upload-filled /></el-icon>
                    <div class="el-upload__text">
                    {{ $t('agent.uploadD', { msg: 'agent.uploadD' }) }} <em>{{ $t('agent.uploadLink', { msg: 'agent.uploadLink' }) }}</em>
                    </div>
                    <template #tip>
                    <div class="el-upload__tip">
                       {{ $t('agent.info', { msg: 'agent.info' }) }}
                    </div>
                    </template>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button size="normal" :loading="loadBtn" type="primary" @click="newAgent('newAgentForm')">{{ $t('agent.btn.new', { msg: 'agent.btn.new' }) }}</el-button>
                <el-button size="normal" type="danger" @click="newAgentVisiableCloseFunc()">{{ $t('agent.btn.cancel', { msg: 'agent.btn.cancel' }) }}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

<script>
import { deleteRequest, getRequest, postRequest } from '../../axios/axios';
import { baseUrl_New } from '../../axios/urlconfig';
import axios from 'axios';

export default {
  data() {
    return {
        allCompany: [],
        tabelData: [],
        search: '',
        newAgentForm:{
            agentName: '',
            agentCode: '',
            companyName: '',
            agentContact: '',
            agentLogo: '',
        },
        loadBtn: false,
        uploadUrl: baseUrl_New + "/oss/file/uploadLogo",
        newAgentRules: {
        agentCode: [
          {required: true, message: this.$t('agent.idD', { msg: 'agent.idD' }) ,trigger: 'blur'},
          {min: 1, max: 7, message: this.$t('agent.lengthD7', { msg: 'agent.lengthD7' }), trigger: 'blur'}
        ],
        agentName: [
          { required: true, message: this.$t('agent.nameD', { msg: 'agent.nameD' }), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('agent.lenthD120', { msg: 'agent.lengthD120' }), trigger: 'blur' }
        ],
        companyName:[
          {required: true, message: this.$t('agent.companyNameD', { msg: 'agent.companyNameD' }) ,trigger: 'blur'},
          {min: 1, max: 10, message: this.$t('agent.lengthD150', { msg: 'agent.lengthD150' }), trigger: 'blur'}
        ],
        agentContact: [
          { required: false, message: this.$t('agent.contentD', { msg: 'agent.contentD' }), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('agent.lengthD120', { msg: 'agent.lengthD120' }), trigger: 'blur' },
          {  pattern: /^1[3-9]\d{9}$/, message: this.$t('agent.onlyNum', { msg: 'agent.ohlyNum' }), trigger: 'blur' }
        ],
        agentLogo: [
            { 
            required: true, 
            validator: (rule, value, callback) => {
                if (value && value.length > 0) {
                callback(); // 通过校验
                } else {
                callback(new Error(this.$t('agent.logoD', { msg: 'agent.logoD' }))); // 未上传图片，校验不通过
                }
            }, 
            trigger: 'blur' 
            }
        ]
      },
        allselectfunc: [{
            label: this.$t('agent.name', { msg: 'agent.name' }),
            value: 'agent_name'
            },{
            label: this.$t('agent.id', { msg: 'agent.id' }),
            value: 'agent_code'
            }],
            selectfunc: "agent_name",
            newAgentVisiable: false,
        }
  },
  created() {
    this.selectList();
    // this.queryLogo();
  },
  methods: {
    handleBeforeUpload(file){
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isPNG) {
          this.$message.error(this.$t('agent.imageD', { msg: 'agent.imageD' }));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('agent.imageSizeD', { msg: 'agent.imageSizeD' }));
        }
        return isPNG && isLt2M;
    },

    selectList(){
        getRequest(baseUrl_New + '/agent/list')
        .then(res => {
            this.tabelData = res;
        
        })
        .catch(err => {
            console.log(err);
        })
    },

    newAgentVisiableFunc(){
        this.newAgentVisiable = true
    },

    // queryLogo() {
    //     getRequest(baseUrl_New + '/agent/querylogo')
    //     .then(response => {
    //         // 处理返回的代理商信息
    //         console.log(response.data);
    //     })
    //     .catch(error => {
    //         // 处理错误
    //         console.error(error);
    //     });
    // },

    newAgentVisiableCloseFunc(){
        this.newAgentForm.agentCode = '';
        this.newAgentForm.agentContact = '';
        this.newAgentForm.agentName = '';
        this.newAgentForm.agentLogo = '';
        this.newAgentForm.companyName = '';
        this.$refs.img.clearFiles();
        this.newAgentVisiable = false
    },

    newAgent(formName){
        this.$refs[formName].validate((valid) => {
        if (valid) {
        this.loadBtn = true;
        postRequest(baseUrl_New + '/agent/addrow',this.newAgentForm)
        .then(res => {
            if(res === '新增成功'){
                this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
                this.selectList();
                this.newAgentVisiableCloseFunc();
                this.$refs.img.clearFiles();
                this.loadBtn = false;
            }else if(res === '数据已存在') {
                this.$message.error(this.$t('agent.sameRow'), {msg: 'agent.sameRow'});
                this.loadBtn = false;
            }else{
                this.$message.error(this.$t('issue.addF', { msg: 'issue.addF' }));
                this.loadBtn = false;
            }
        })
        .catch(err => {
            this.$message.error(err.data)
            console.log(err);
        })
        } 
      });
    },

    handleUploadSuccess(res, file, fileList){
        this.newAgentForm.agentLogo = res.data.url;
    },

    getAllCompany(){
        this.allCompany.splice(0,this.allCompany.length)
        getRequest(baseUrl_New + '/company/getlist')
        .then(res => {
            for(let i = 0;i < res.length; i++){
                this.allCompany.push({
                    key: res[i].companyname,
                    label: res[i].companyname,
                    value: res[i].companyname,
                });
            }
        })
        .catch(err => {

        })
    },

    delAgent(index,id){
        this.$confirm(this.$t('agent.deleteDF', { msg: 'agent.deleteDF' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
        confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
        cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        deleteRequest(baseUrl_New + `/agent//${id}`)
        .then(res=>{
            if (res === "删除成功"){
                this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
                this.selectList();
            } else {
                this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
            }
        })
      })
      },

      handleUpload(){
        console.log("upload!");
      },

    selectFunc(){
    getRequest(baseUrl_New + '/agent/query/' + this.selectfunc + '/' + this.search).then(res => {
        this.tabelData = res;
        }).catch(err => {
        console.log(err)
        })
    },
    reset(){
        this.selectList();
        this.search = '';
    }
  }
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>